"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityCacheOptions = void 0;
var to_array_1 = require("./to-array");
var lodash_1 = require("lodash");
var entityCacheOptions = function (data, context, fieldEntities) {
  return data ? (0, lodash_1.mapValues)(fieldEntities, function (entityConfig, field) {
    return (0, lodash_1.filter)((0, to_array_1.toArray)(data[field]).map(function (item) {
      if (entityConfig) {
        return entityConfig.select.transform(item, context);
      }
    }));
  }) : {};
};
exports.entityCacheOptions = entityCacheOptions;